import GlobalSearch from './GlobalSearch';
export { default as useGlobalSearch } from './useGlobalSearch';
export default GlobalSearch;
